import { Injectable } from '@angular/core';
import { ConfigRequestsInterface, InitializableInterface } from '@evorait/pace-core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfigInterfaceService implements ConfigRequestsInterface, InitializableInterface {
    public isInitialized = false;
    public offlineStoreDefiningRequests: string[];

    public init(): Observable<string[]> {
        this.offlineStoreDefiningRequests = [];

        this.isInitialized = true;

        return of(this.offlineStoreDefiningRequests);
    }
}
